/** Compact page list: 1 2 3 ... last */
export function buildCompactPageRange(current, total) {
    if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }
    const pages = [1];
    const windowStart = Math.max(2, current - 1);
    const windowEnd = Math.min(total - 1, current + 1);
    if (windowStart > 2)
        pages.push('ellipsis');
    for (let p = windowStart; p <= windowEnd; p += 1)
        pages.push(p);
    if (windowEnd < total - 1)
        pages.push('ellipsis');
    if (total > 1)
        pages.push(total);
    return pages;
}
